(function () {
  function init(root) {
    if (!root || root.dataset.zdWallCalcReady === "1") return;
    var widthInput=root.querySelector("#zdv-width");
    var heightInput=root.querySelector("#zdv-height");
    var areaOut=root.querySelector("#zdv-area");
    var rollsOut=root.querySelector("#zdv-rolls");
    var noteOut=root.querySelector("#zdv-rollnote");
    if(!widthInput||!heightInput||!areaOut||!rollsOut)return;
    function update(){
      var w=parseFloat(widthInput.value),h=parseFloat(heightInput.value);
      if(!Number.isFinite(w)||!Number.isFinite(h)||w<=0||h<=0){
        areaOut.textContent="—";rollsOut.textContent="Enter valid dimensions";
        if(noteOut)noteOut.textContent="Enter wall width and height greater than zero.";
        return;
      }
      var area=w*h,rolls=Math.max(1,Math.ceil(area*1.1/12.9));
      areaOut.textContent=area.toFixed(1)+" sq. ft.";
      rollsOut.textContent=rolls+" roll"+(rolls===1?"":"s");
      if(noteOut)noteOut.textContent="Includes approx. 10% allowance; each roll is 40 cm × 3 m.";
    }
    widthInput.addEventListener("input",update);heightInput.addEventListener("input",update);
    root.dataset.zdWallCalcReady="1";update();
  }
  function initAll(){var root=document.getElementById("zdv2");if(root)init(root);}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initAll,{once:true});else initAll();
  document.addEventListener("shopify:section:load",initAll);
})();